export default __webpack_public_path__ + "images/5bfeef4260bbac93269c763eeebd3c3c-books.jpg";